var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolboxSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "toolbox-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 52.5,
    viewBox: "0 0 60 52.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "toolbox-solid-2",
    "data-name": "toolbox-solid",
    d: "M20.625,38.563V43.25h18.75V38.563a.94.94,0,0,0-.937-.937H21.562A.94.94,0,0,0,20.625,38.563ZM15,43.25V38.563A6.567,6.567,0,0,1,21.562,32H38.437A6.567,6.567,0,0,1,45,38.563V43.25h3.293A5.625,5.625,0,0,1,52.266,44.9l6.082,6.082A5.625,5.625,0,0,1,60,54.957v8.918H45V62a3.75,3.75,0,1,0-7.5,0v1.875h-15V62A3.75,3.75,0,0,0,15,62v1.875H0V54.957a5.625,5.625,0,0,1,1.652-3.973L7.734,44.9a5.625,5.625,0,0,1,3.973-1.652ZM0,77V67.625H15V69.5a3.75,3.75,0,0,0,7.5,0V67.625h15V69.5a3.75,3.75,0,1,0,7.5,0V67.625H60V77a7.507,7.507,0,0,1-7.5,7.5H7.5A7.507,7.507,0,0,1,0,77Z",
    transform: "translate(0 -32)",
    fill: "#a4a4a4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolboxSolid);
export default __webpack_public_path__ + "static/media/toolbox-solid.403cd7e7ccd92315dcbbce1f5167fa55.svg";
export { ForwardRef as ReactComponent };